import React from 'react';
//import clone from 'clone';

class PageSizeSelector extends React.Component {
  constructor( props ) {
    super( props );
    this.OPTION_NONE = 0;
    this.OPTION_DEFAULT = 50;
    this.PageSizeSelectorOptions = {
      OPTION_25: 25,
      OPTION_50: 50,
      OPTION_75: 75,
      OPTION_100: 100,
      OPTION_500: 500,
      OPTION_1000: 1000,
    };

    this.state = {
      totalRecords: props.totalRecords === undefined ? 0 : props.totalRecords,
      currentValue: this.OPTION_NONE,
      hasError: false,
      error: {},
      info: {}
    };
  }

  static getDerivedStateFromProps( props, state ) {
    let newState = state;
    let stateChanged = false;

    if( props.totalRecords !== undefined ) {
      if( props.totalRecords !== state.totalRecords ) {
        newState.totalRecords = props.totalRecords;
        stateChanged = true;
      }
    }

    if( stateChanged === true ) {
      return newState;
    }

    return null;
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  // Components Events
  onHandleChange = ( e ) => {
    const pageSize = parseInt( e.target.value, 10 );

    if( this.props.onPageSizeChanged !== undefined ) {
      this.props.onPageSizeChanged( pageSize );
    }

    this.setState( { 
      currentValue: pageSize
    } );
  }

  //Components Render Functions
  onRenderPageSizeItems() {
    let pageSizeOptions = [];
    let selected = false;
    const currentValue = this.state.currentValue === this.OPTION_NONE ? this.OPTION_DEFAULT : this.state.currentValue;
    const optionsKeys = Object.keys(this.PageSizeSelectorOptions);
    for( let optionIndex = 0; optionIndex < optionsKeys.length; optionIndex++ ) {
      const optionKey = optionsKeys[ optionIndex ];
      const optionValue = this.PageSizeSelectorOptions[ optionKey ];
      if( this.state.totalRecords >= optionValue ) {
        selected = currentValue === optionValue ? true : false;
        const controlKey = 'page-size-selector-option-' + optionValue.toString();
        pageSizeOptions.push( 
          <option key={controlKey} 
                  selected={selected} 
                  value={optionValue} 
                  className="page-size-selector-option">
            {optionValue.toString()}
          </option> 
        );
      }
    }
    return pageSizeOptions;
  }

  render( ) {
    if( this.state.hasError === false ) {
      if( this.state.totalRecords >= 25 ) {
        return (
          <span className="page-size-selector">
            <span className="page-size-selector-label">Show</span>
            <select className="page-size-selector-dropdown" onChange={this.onHandleChange}>
              {this.onRenderPageSizeItems()}
            </select>
            <span className="page-size-selector-label">Entries</span>
          </span>
        );
      }
    }
    return ( <span></span> );
  }
}

export default PageSizeSelector;



// WEBPACK FOOTER //
// ./src/presentation/PageSizeSelector.js